import actionCreatorFactory from "typescript-fsa";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { Job } from "../types/types";
import { RootState } from "./index.store";

/* Selectors */
/**
 * 全てのジョブを返す
 * @param state
 */
export const jobsSelector = (state: RootState) => state.domain.jobs;

/* Actions */
const actionCreator = actionCreatorFactory("jobs");
export const jobsActions = {
  /* SYSTEM ACTIONS */
  SYSTEM_FETCH_ALL_JOBS: actionCreator("SYSTEM_FETCH_ALL_JOBS"),
  /* USER ACTIONS */
  /* REDUCER ACTIONS */
  REDUCER_SET_JOBS: actionCreator<Job[]>("REDUCER_SET_JOBS")
};

/**
 * ジョブリデューサー
 */
export const jobReducer = reducerWithInitialState<Job[]>([]).case(
  jobsActions.REDUCER_SET_JOBS,
  (state, payload) => payload
);
